// Application types

const RESTAURANT = {
  LOADING_RESTAURANT: "LOADING_RESTAURANT",
  LOADING_MORE: "LOADING_MORE",
  LOADING_SEARCH:"LOADING_SEARCH",
  ALL_RESTAURANTS: "ALL_RESTAURANTS",
  MORE_RESTAURANTS: "MORE_RESTAURANTS",
  SINGLE_RESTAURANT: "SINGLE_RESTAURANT",
  SEARCH_RESTAURANT: "SEARCH_RESTAURANT",
  FILTER_RESTAURANTS: "FILTER_RESTAURANTS",
  LOADING_FEEDBACK: "LOADING_FEEDBACK",
  GET_RESTAURANT_FEEDBACK: "GET_RESTAURANT_FEEDBACK",
};

export default RESTAURANT;
